var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt-5 carousel-container",attrs:{"id":"ManagerSupportContent"}},[_c('HomeFilters',{attrs:{"title":"Filters","hardcoded-tags":[
      'Manager guidance',
      'Life',
      'Mind',
      'Body',
      'Working well'
    ],"starting-tag":"Manager guidance"}}),_c('HomeCardCarousel',{staticClass:"car",attrs:{"title":"Videos","type":"standaloneArticles","additionalTag":"Videos","mute":true,"starting-tag":"Manager guidance"}}),_c('HomeCardCarousel',{staticClass:"car",attrs:{"title":"Articles","cardType":"article","type":"standaloneArticles","additionalTag":"Articles","mute":true,"starting-tag":"Manager guidance"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }